import { Skeleton } from '@/components/ui/skeleton';

/** Shown while a lane's route bundle is still loading. */
export function RouteFallback() {
  return (
    <div className="space-y-4 p-6" aria-busy="true" aria-label="Loading page">
      <Skeleton className="h-7 w-52" />
      <Skeleton className="h-4 w-80" />
      <div className="space-y-2 pt-4">
        {Array.from({ length: 8 }).map((_, i) => (
          <Skeleton key={i} className="h-9 w-full" />
        ))}
      </div>
    </div>
  );
}
